import SignupSidebar from '../../component/Signup/SignupSidebar'
import AboutCompany from '../../component/Signup/AboutCompany'
import AboutYou from '../../component/Signup/AboutYou'
import SetPassword from '../../component/Signup/SetPassword'
import { useFormik } from 'formik'
import { showMessage } from '../../utils/toast/globalToast'
import { _sessionKeys, _sessionType, _toastVariants, FILE_UPLOAD_DIR } from '../../utils/Constant'
import { aboutCompanyValidation, aboutYouValidation, passwordValidation } from '../../component/Signup/validations'
import { useEffect, useState } from 'react'
import Getotp from '../../component/Signup/Getotp'
import Emailotp from '../../component/Signup/Emailotp'
import { useLocation, useNavigate } from 'react-router-dom'
import { apiUrl } from '../../utils/endPoints/apiUrl'
import { apiRequest } from '../../utils/config/apiRequest'
import { uploadFile } from '../../utils/helper/appHelpers'
import { _vendorAdminRoutes } from '../../utils/appRouter'
import { accessSessionData } from '../../utils/helper/authHelper'

const Signup = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // const loggedUser = JSON.parse(accessSessionData(_sessionType.getdata, _sessionKeys.loggedInUser));
  const loggedUser = JSON.parse(localStorage.getItem("loggedInUser"));


  const [isDisabled, setAllFieldsDisabled] = useState(false);
  const [showUnderProcessModal, setShowUnderProcessModal] = useState(false);


  const [sideBarState, setSideBarState] = useState({
    aboutCompany: { isCompleted: true, isActive: true },
    aboutYou: { isCompleted: false, isActive: false },
    mobileOtp: { isCompleted: false, isActive: false },
    emailOtp: { isCompleted: false, isActive: false },
    setPassword: { isCompleted: false, isActive: false },
  });
  const [otpToken, setOtpToken] = useState({
    mobile: "",
    email: "",
  });

  const initialValues = {
    // company details
    businessLogo: "",
    businessName: "",
    businessType: "store",
    businessLocation: {
      state: '',
      country: '',
      city: '',
      pincode: '',
      latitude: 0,
      longitude: 0,
      address: "",
      street: '',
    },
    registrationDocuments: [{ name: "", expiryDate: "", attachments: [] }],
    idProof: [{ name: "", expiryDate: "", attachments: [] }],
    // about you
    fullName: "",
    email: "",
    dialCode: "",
    mobile: "",
    // set password
    password: "",
    passwordResetEmail: "",
  };

  const validationSchema = aboutCompanyValidation
    .concat(aboutYouValidation)
    .concat(passwordValidation);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {

        const upoladLogo = await uploadFile(values.businessLogo, "profilePic");

   
        const uploadedRegistrationDocs = await Promise.all(
          values.registrationDocuments.map(async (doc) => {
            const uploadedFiles = await Promise.all(
              (doc.attachments || []).map(async (file) => await uploadFile(file, FILE_UPLOAD_DIR.SHOP))
            );
            return {
              ...doc,
              attachments: uploadedFiles,
            };
          })
        );

        const uploadedIdProofs = await Promise.all(
          values.idProof.map(async (doc) => {
            const uploadedFiles = await Promise.all(
              (doc.attachments || []).map(async (file) => await uploadFile(file, "idProof"))
            );
            return {
              ...doc,
              attachments: uploadedFiles,
            };
          })
        );
        const payload = {
          userName: values.fullName,
          mobileOTPToken: otpToken.mobile,
          emailOTPToken: otpToken.email,
          isVendor: true,
          profilePic: upoladLogo,
          businessInfo: {
            logo: upoladLogo,
            name: values.businessName,
            location: values.businessLocation,
            documents: uploadedRegistrationDocs,
            idProof: uploadedIdProofs,

          },
          password: values.password,
          businessType: values.businessType,
          email: values.email,
          dialCode: values.dialCode,
          mobile: values.mobile,
        };

        const { status, message } = await apiRequest({
          endUrl: apiUrl.userRegistration,
          method: 'POST',
          body: payload,
          showMsg: true
        });
        if (status) {
          showMessage({ variant: _toastVariants.Success, message: "Registration successful! Please log in." });
          // navigate to login or another page if needed
          navigate(_vendorAdminRoutes.login);
        }
      } catch (error) {
        showMessage({ variant: _toastVariants.Error, message: error.message });
      } finally {
        setSubmitting(false);
      }
    },
  });

  const { handleSubmit } = formik;


  useEffect(() => {
  if (location.state?.fromLogin && loggedUser && !loggedUser.isApproved) {

    formik.setValues({
      ...formik.values,
      fullName: loggedUser.fullName,
      email: loggedUser.email,
      mobile: loggedUser.mobile,

      businessName: loggedUser.businessInfo?.name || "",
      businessType: loggedUser.businessType || "store",

      businessLocation: loggedUser.businessInfo?.location || {
        state: '',
        country: '',
        city: '',
        pincode: '',
        latitude: 0,
        longitude: 0,
        address: "",
        street: '',
      }
    });

    setAllFieldsDisabled(true);

    setShowUnderProcessModal(true);
  }
  }, [location]);

  return (
    <div>

      {showUnderProcessModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3 className="modal-title">Vendor Verification Pending</h3>
            <p className="modal-message">
              Your vendor application is under review.  
              You will be notified once it is approved.
            </p>
            <button
              className="btn btn-dark"
              onClick={() => setShowUnderProcessModal(false)}
            >
              Okay
          </button>
          </div>
        </div>
      )}


      <div className="wrapper">
        <div className="signup-wrapper py-5">
          <div className="container d-flex align-items-center justify-content-center">
            <div className="row signupbox">
              <SignupSidebar sideBarState={sideBarState} />

              {/* Render active component dynamically */}
              {sideBarState.aboutCompany.isActive && <AboutCompany formik={formik} setSideBarState={setSideBarState} sideBarState={sideBarState} validationSchema={validationSchema} isDisabled={isDisabled}/>}
              {sideBarState.aboutYou.isActive && <AboutYou formik={formik} setSideBarState={setSideBarState} setOtpToken={setOtpToken}/>}
              {sideBarState.mobileOtp.isActive && <Getotp formik={formik} setSideBarState={setSideBarState} otpToken={otpToken} setOtpToken={setOtpToken}/>}
              {sideBarState.emailOtp.isActive && <Emailotp formik={formik} setSideBarState={setSideBarState} otpToken={otpToken} setOtpToken={setOtpToken} />}
              {sideBarState.setPassword.isActive && <SetPassword formik={formik} setSideBarState={setSideBarState} handleSubmit={handleSubmit}/>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signup;
